import React, {useState} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { showModal } from "../../features/modal/modalSlice";
import { companiesProjectApprove, setSelectedProject } from "../../features/isOrtaklari/isOrtaklariSlice";


const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        align-items: center;
        justify-content: center;
        height: auto;
        gap: 15px;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          text-align: center;
          display: flex;
          flex-direction: column;
          gap: 10px;
          .companies{
            display: flex;
            flex-direction: column;
            min-height: 30px;
            align-items: center;
            justify-content: center;
          }
          p{
            color: var(--color-main);
            border: 1px solid var(--color-main);
            width: 100px;
            border-radius: 5px;
            padding: 5px;
            height: 100%;
          }
        }
      }
    }
  }
  .btn{
    flex-direction: row !important;
    justify-content: center;
    display: flex;
    gap: 10px;
  }
  
`;

const IsOrtaklariContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const {getIsLoading} = useSelector((state)=> state.companyProfile)
  const dispatch = useDispatch();

  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const userId = JSON.parse(storage.getItem("userId"))
  const companyId = JSON.parse(storage.getItem("companyId"))

  const projectDetail = () => {
    if(data?.digitalLogisticId === companyId){
      dispatch(showModal("projeDetay"))
      dispatch(setSelectedProject(data))
    }
  }
  
  return (
    <Container onClick={projectDetail} theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{data?.projectName}</div>
            <div className="col">{data?.digitalLogisticCompanyName}</div>
            <div className="col">
              {data?.loadOwnerCompanyDtos?.map((item) => (
                <div className="companies">{item?.loadOwnerCompanyName}</div> 
              ))}
            </div>
            <div className="col">
              {data?.loadOwnerCompanyDtos?.map((item) => {
                return(
                <div className="companies">
                  {(data?.digitalLogisticId === companyId && item?.isApproved === false) && <div className="item">Onay Bekliyor</div> }
                  {item?.isApproved === true && <div className="item">Onaylandı</div>}
                  {(data?.digitalLogisticId !== companyId && item?.isApproved === false && item?.loadOwnerCompanyId === companyId) && 
                    <div className="item btn"> 
                      <p onClick={() => dispatch(companiesProjectApprove({id: data?.id, isApproved: true}))} >Onayla</p> 
                      <p onClick={() => dispatch(companiesProjectApprove({id: data?.id, isApproved: false}))} >Reddet</p> 
                    </div>
                  }
                </div>
              )})}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default IsOrtaklariContainer;
